import {Link} from 'react-router-dom'
import {HashLink} from 'react-router-hash-link'

import {CreditstarLogoWhite, MobileMenuClose} from '../../assets/icons'
import {APP_ROUTES} from '../../routes/routes'

const HeaderMobileMenu = ({close}) => {
  const aboutLinks = [
    {id: 'about-markets', label: 'Markets'},
    {id: 'about-values', label: 'Core values'},
    {id: 'about-team', label: 'Leadership team'}
  ]

  const productsLinks = [
    {id: 'products-brands', label: 'Overview'},
    {id: 'products-our-products', label: 'Our products'},
    {id: 'products-countries', label: 'Geographical reach '}
  ]

  const careerLinks = [
    {id: 'careers-open-positions', label: 'Job openings'},
    {id: 'reasons', label: 'Life at Creditstar'}
  ]

  const moreLinks = [
    {id: 'bonds', path: APP_ROUTES.BONDS, label: 'Investors'},
    {id: 'news', path: APP_ROUTES.NEWS, label: 'News'},
    {id: 'contacts', path: APP_ROUTES.CONTACTS, label: 'Contacts'}
  ]

  return (
    <div id="mobile-menu">
      <div className="mobile-menu-header-wrapper">
        <div className="mobile-menu-logo">
          <CreditstarLogoWhite />
        </div>
        <div className="mobile-menu-close" onClick={close}>
          <MobileMenuClose />
        </div>
      </div>
      <div className="mobile-menu-paths-wrapper">
        <div className="mobile-menu-path section-title">
          <Link to={APP_ROUTES.ABOUT} onClick={close}>
            About us
          </Link>
        </div>

        {aboutLinks.map(({id, label}) => {
          return (
            <div className="mobile-menu-path" key={`mobile-menu-path-${id}`}>
              <HashLink to={`${APP_ROUTES.ABOUT}#${id}`} onClick={close}>
                {label}
              </HashLink>
            </div>
          )
        })}

        <div className="mobile-menu-path section-title">
          <Link to={APP_ROUTES.PRODUCTS} onClick={close}>
            Products
          </Link>
        </div>

        {productsLinks.map(({id, label}) => {
          return (
            <div className="mobile-menu-path" key={`mobile-menu-path-${id}`}>
              <HashLink to={`${APP_ROUTES.PRODUCTS}#${id}`} onClick={close}>
                {label}
              </HashLink>
            </div>
          )
        })}

        <div className="mobile-menu-path section-title">
          <Link to={APP_ROUTES.CAREERS} onClick={close}>
            Careers
          </Link>
        </div>

        {careerLinks.map(({id, label}) => {
          return (
            <div className="mobile-menu-path" key={`mobile-menu-path-${id}`}>
              <HashLink to={`${APP_ROUTES.CAREERS}#${id}`} onClick={close}>
                {label}
              </HashLink>
            </div>
          )
        })}

        <div className="mobile-menu-path section-title">
          <Link to="#" onClick={close}>
            More
          </Link>
        </div>

        {moreLinks.map(({id, label, path}) => {
          return (
            <div className="mobile-menu-path" key={`mobile-menu-path-${id}`}>
              <HashLink to={`${path}`} onClick={close}>
                {label}
              </HashLink>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default HeaderMobileMenu
